exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-number[data-v-484b7acc]{overflow:hidden;position:relative;display:inline-block}.v-number__current-value[data-v-484b7acc]{position:absolute}.v-number__original-value[data-v-484b7acc]{visibility:hidden}.v-number__animated[data-v-484b7acc]{position:absolute;-webkit-transition-property:top;transition-property:top;-webkit-transition-timing-function:ease-in-out;transition-timing-function:ease-in-out}.v-number-new-value-enter[data-v-484b7acc]{top:-100%}.v-number-current-value-leave[data-v-484b7acc],.v-number-new-value-enter-to[data-v-484b7acc]{top:0}.v-number-current-value-leave-to[data-v-484b7acc]{top:100%}", ""]);

// exports
